import React from 'react';
import Chat from 'components/chat';
import UserList from 'components/users';
import Accordion from './accordion';
import { getSearchParam } from 'utils/params';
import './index.scss';

const showParticipants = getSearchParam('participants') === '1';

const Application = () => {
  return (
    <div className="application">
      <div className="application-chat">
        <Chat />
      </div>
      {showParticipants && (
        <Accordion title="Participants" defaultOpen={false}>
          <div className="accordion-users">
            <UserList />
          </div>
        </Accordion>
      )}
    </div>
  );
};

const areEqual = () => true;

export default React.memo(Application, areEqual);
